export default __webpack_public_path__ + "6cf1079502df85efce7cf12cced761c8.png";